import script from "./ServiceCenter.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCenter.vue?vue&type=script&setup=true&lang=js"

import "./ServiceCenter.vue?vue&type=style&index=0&id=b2182034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b2182034"]])

export default __exports__